/* eslint-disable no-undef */
// 公共js
import router from '../../src/router'
import store from '../../src/store'
import { MessageBox } from 'mint-ui'
import { Loading } from 'element-ui'
import axios from '../../src/api/http'
export default {
  data: {
    loading: null,
    wgtUrl: '',
    versionNo: '',
    uuid: ''
  },
  tips(msg, fun) {
    if (msg === '请重新登录') {
      MessageBox.alert('请重新登录!').then(() => {
        store.commit('USER_SIGNOUT')
        router.replace('/login')
      })
    } else {
      if (fun) {
        fun()
      } else {
        MessageBox('提示', msg)
      }
    }
  },
  error() {
    var p = plus.audio.createPlayer('_www/static/media/error.wav')
    p && p.play()
  },
  upDataVersion() {
    let fileName = ''
    let wgtUrl = ''
    const that = this
    function plusReady() {
      // 获取本地应用资源版本号
      plus.runtime.getProperty(plus.runtime.appid, inf => {
        that.data.versionNo = inf.version
        checkUpdate()
      })
      that.data.uuid = plus.device.uuid
    }
    if (window.plus) {
      plusReady()
    } else {
      document.addEventListener('plusready', plusReady, false)
    }
    // 版本更新
    function checkUpdate() {
      axios.get('/wms4j/version/getLatest.do', { params: { versionNo: that.data.versionNo }}).then(res => {
        if (res.data.statusNum) {
          if (res.data.result && typeof res.data.result !== 'string') {
            const str = `发现新版本v${res.data.result.versionNo},需要进行更新!
      				<div class="text-left"><strong>更新内容说明：</strong>
      				<p style="font-size:15px">${res.data.result.comment.replace('\r\n', '<br />')}</p></div>`
            wgtUrl = res.data.result.versionUrl
            MessageBox.close()
            MessageBox({ message: str, confirmButtonText: '立即更新', closeOnClickModal: false, confirmButtonClass: 'mint-button--primary' }).then(action => {
              downWgt()
            })
          }
        }
      }).catch(error => {
        console.log('检测更新失败！', error)
        // plus.nativeUI.alert('检测更新失败！')
      })
    }

    // 下载wgt文件
    function downWgt() {
      plus.nativeUI.showWaiting('下载最新版本资源中...')
      console.log(wgtUrl)
      plus.downloader.createDownload(wgtUrl, { filename: '_doc/update/' }, function(d, status) {
        if (status === 200) {
          console.log('下载最新版本资源成功：' + d.filename)
          fileName = d.filename
          plus.nativeUI.closeWaiting()
          installWgt(d.filename) // 安装wgt包
        } else {
          console.log('下载最新版本资源失败！')
          plus.nativeUI.alert('下载最新版本资源失败！')
          plus.nativeUI.closeWaiting()
        }
      }).start()
    }
    // 更新应用资源
    function installWgt(path) {
      plus.nativeUI.showWaiting('版本更新中...')
      plus.runtime.install(path, {}, function() {
        plus.nativeUI.closeWaiting()
        console.log('安装wgt文件成功！')
        MessageBox.alert('应用资源更新完成!').then(action => {
          plus.io.resolveLocalFileSystemURL(fileName, function(entry) {
            entry.remove(function() {
              plus.runtime.restart()
              console.log('删除wgt文件成功！')
            })
          })
        })
      }, function(e) {
        plus.nativeUI.closeWaiting()
        console.log('版本更新失败[' + e.code + ']：' + e.message)
        plus.nativeUI.alert('版本更新失败[' + e.code + ']：' + e.message)
      })
    }
  },
  hideSoftKeybord(input) { // 切换下一个input框
    input.focus()
    if (typeof plus !== 'undefined') {
      setTimeout(function() {
        // eslint-disable-next-line no-undef
        plus.key.hideSoftKeybord()
      }, 30)
    }
    return false
  },
  numAdd(arg1, arg2) {
    var r1, r2, m, c
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    c = Math.abs(r1 - r2)
    m = Math.pow(10, Math.max(r1, r2))
    if (c > 0) {
      var cm = Math.pow(10, c)
      if (r1 > r2) {
        arg1 = Number(arg1.toString().replace('.', ''))
        arg2 = Number(arg2.toString().replace('.', '')) * cm
      } else {
        arg1 = Number(arg1.toString().replace('.', '')) * cm
        arg2 = Number(arg2.toString().replace('.', ''))
      }
    } else {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', ''))
    }
    return (arg1 + arg2) / m
  },
  numDiv(num1, num2) {
    let baseNum1 = 0; let baseNum2 = 0
    let baseNum3 = ''
    let baseNum4 = ''
    try {
      baseNum1 = num1.toString().split('.')[1].length
    } catch (e) {
      baseNum1 = 0
    }
    try {
      baseNum2 = num2.toString().split('.')[1].length
    } catch (e) {
      baseNum2 = 0
    }

    baseNum3 = Number(num1.toString().replace('.', ''))
    baseNum4 = Number(num2.toString().replace('.', ''))
    return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1)
  },
  numMulti(num1, num2) { // 乘法
    let baseNum = 0
    try {
      baseNum += num1.toString().split('.')[1].length
    } catch (e) {
      baseNum += 0
    }
    try {
      baseNum += num2.toString().split('.')[1].length
    } catch (e) {
      baseNum += 0
    }
    return Number(num1.toString().replace('.', '')) *
			Number(num2.toString().replace('.', '')) /
			Math.pow(10, baseNum)
  },
  loadings(text) {
    this.data.loading = Loading.service({
      lock: true,
      text: text || 'Loading...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  loadClose() {
    this.data.loading.close()
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/base.js
// module id = Qfcr
// module chunks = 37